import {
  addDays,
  addMonths,
  format,
  getDaysInMonth,
  milliseconds,
  startOfWeek,
  startOfYear,
} from 'date-fns';
import type { Locale } from 'date-fns';
import {
  de,
  da,
  enGB,
  enUS,
  es,
  fi,
  fr,
  it,
  nl,
  nb,
  pl,
  pt,
  sv,
  tr,
} from 'date-fns/locale';

import type { PrecisionTypes } from './definitions';
import { DateFormat } from './definitions';

export function months(
  monthFormat: string = DateFormat.MonthFullName
): string[] {
  const monthsInAYear = 12;
  const firstDayOfYear = startOfYear(new Date());

  return Array.from(Array(monthsInAYear)).map((_, i: number) =>
    format(addMonths(firstDayOfYear, i), monthFormat)
  );
}

export function weekdays(dayFormat: string = DateFormat.FullDayName): string[] {
  const daysInAWeek = 7;
  const firstDayOfWeek = startOfWeek(new Date());

  return Array.from(Array(daysInAWeek)).map((_, i: number) =>
    format(addDays(firstDayOfWeek, i), dayFormat)
  );
}

export function getFirstWeekdayJsIndex(): number {
  const firstDayOfWeek = startOfWeek(new Date());
  return firstDayOfWeek.getDay();
}

export function getLocale(langCode?: string): Locale {
  switch (langCode) {
    case 'de':
      return de;
    case 'dk':
    case 'da':
      return da;
    case 'en':
      return enGB;
    case 'es':
      return es;
    case 'fi':
      return fi;
    case 'fr':
      return fr;
    case 'it':
      return it;
    case 'nl':
      return nl;
    case 'no':
    case 'nb':
      return nb;
    case 'pl':
      return pl;
    case 'pt':
      return pt;
    case 'sv':
      return sv;
    case 'tr':
      return tr;
    case 'enUS':
      return enUS;
    default:
      return enGB;
  }
}

export function durationInMs(duration: number, unit: PrecisionTypes): number {
  if (unit === 'millisecond') {
    return duration;
  }

  return milliseconds({ [`${unit}s`]: duration });
}

export function daysInMonth(date: Date): number {
  return getDaysInMonth(date);
}
